<app-card
  [className]="'card--summary'"
  *ngFor="let project of childProjects"
  [childProject]="project"
  [type]="CardType.CHILDPROJECT"
>
</app-card>
